import * as Yup from 'yup';

import { PhoneService } from '../../../entities/Phone/service';
import { errMessageMoreThen } from './constants';

export const blackListSchema = (schema: any) =>
  Yup.object().shape({
    number: (() => {
      if (schema === 'driver' || schema === 'forwarder')
        return Yup.string().test('len', 'Поле "Телефон" повинно містити 12 символів', (value = '') => {
          const changedValue = PhoneService.unformatPhone(value);
          return changedValue.length === 12;
        });
      if (schema === 'vehicle' || schema === 'trailer')
        return Yup.string()
          .trim()
          .min(4, 'Поле "Держномер" повинно містити не менше 4-х символів')
          .max(10, 'Поле "Держномер" повинно містити не більше 10-х символів')
          .required('Поле "Держномер" обов\'язкове');
      return Yup.string();
    })(),
    description: Yup.string().required("Поле обов'язкове"),
    comment: Yup.string().min(3, 'Поле "Коментар" має містити не менше 3-х символів').required(errMessageMoreThen),
  });
